import React, { useEffect, useRef, useState } from "react";
import * as OV from "online-3d-viewer";
import { ProgressBar } from "baseui/progress-bar";

const ObjViewer = ({ url, objName }) => {
  const parentDiv = useRef(null);
  const viewerRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const downloadModelAsFile = (modelUrl) => {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", modelUrl);
        xhr.responseType = "blob"; // Important for handling the binary data

        xhr.onprogress = (event) => {
          if (event.lengthComputable) {
            const percentage = Math.round((event.loaded / event.total) * 100);
            setProgress(percentage);
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) {
            const blob = xhr.response;
            const filename = objName; // Use the provided objName
            const file = new File([blob], filename, { type: blob.type });
            resolve(file);
          } else {
            reject(new Error("Failed to download model"));
          }
        };

        xhr.onerror = () => reject(new Error("Network error"));
        xhr.send();
      });
    };

    const initViewer = async () => {
      if (!url) {
        console.error("Model URL not provided.");
        return;
      }

      try {
        const modelFile = await downloadModelAsFile(url);

        if (viewerRef.current === null) {
          OV.SetExternalLibLocation('/libs');
          
          const parameters = {
            backgroundColor: new OV.RGBAColor(125, 125, 125, 255),
            defaultColor: new OV.RGBColor(200, 200, 200),
            // Other viewer parameters...
          };

          viewerRef.current = OV.Init3DViewerFromFileList(parentDiv.current, [modelFile], parameters);
        }
      } catch (error) {
        console.error("Error initializing viewer or loading model:", error);
      }
    };

    initViewer();

    return () => {
      if (viewerRef.current) {
        viewerRef.current.Destroy();
      }
    };
  }, [url, objName]);

  return (
    <div>
 {progress < 100 ? (
        <ProgressBar 
        overrides={{
            BarProgress: {
              style: ({$theme, $value}) => {
                return {
                  ...$theme.typography.font350,
                //   backgroundColor: $theme.colors.positive,
                  color: $theme.colors.mono200,
                  position: 'relative',
                  ':after': {
                    position: 'absolute',
                    content: $value > 5 ? `"${$value}%"` : '',
                    right: '10px',
                  },
                };
              },
            },
            Bar: {
              style: ({$theme}) => ({
                height: $theme.sizing.scale800,
              }),
            },
          }}
        
        value={progress} successValue={100} />
      ) : null}      
      <div ref={parentDiv}  style={{ width: "100%", height: "50vh" }} />
    </div>
  );
};

export default ObjViewer;
